<template>
  <div class="itinerario-con-sello" ref="contenedorRef">
    <!-- Sello superior -->
    <img src="@/assets/sello.avif" alt="Sello decorativo" class="sello-superior" />

    <!-- Encabezado -->
    <div class="encabezado">
      <h2 class="titulo">Itinerario<br> <span class="script">Del Evento</span></h2>
    </div>

    <!-- Línea de eventos -->
    <div class="linea-eventos">
      <div
        v-for="(evento, index) in eventos"
        :key="index"
        :ref="el => { if (el) eventosRef[index] = el }"
        class="bloque-evento"
      >
        <img :src="evento.icono" class="icono-evento" alt="Icono evento" />
        <div class="detalle">
          <h3>{{ evento.titulo }}</h3>
          <p>{{ evento.hora }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'ItinerarioEleganteConSello',
  setup() {
    const eventosRef = ref([])
    const contenedorRef = ref(null)

    const eventos = [
      { titulo: 'Ceremonia Religiosa ', hora: '1:00 p.m.', icono: require('@/assets/ceremonia_time.png') },
      { titulo: 'Recepción', hora: '3:00 p.m.', icono: require('@/assets/bebidas.png') },
      { titulo: 'Comida ', hora: '4:00 p.m.', icono: require('@/assets/cena_time.png') },
      { titulo: 'Baile', hora: '7:00 p.m - 1:00 a.m.', icono: require('@/assets/fiesta_time.png') }
    ]

    onMounted(() => {
      eventosRef.value.forEach((el) => {
        gsap.set(el, { opacity: 0, y: 50 })
      })

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const index = eventosRef.value.findIndex(e => e === entry.target)
          if (entry.isIntersecting && index !== -1) {
            gsap.to(entry.target, {
              opacity: 1,
              y: 0,
              duration: 0.8,
              delay: index * 0.2,
              ease: 'power3.out'
            })
            observer.unobserve(entry.target)
          }
        })
      }, {
        threshold: 0.4
      })

      eventosRef.value.forEach(el => el && observer.observe(el))
    })

    return {
      eventos,
      eventosRef,
      contenedorRef
    }
  }
}
</script>
<style scoped>
.itinerario-con-sello {
  background-color: #817b76;
  width: 90%;
  margin: 0 auto;
  border-radius: 80px 0 0 80px;
  padding: 100px 30px 60px;
  position: relative;
  text-align: center;
  color: white;
  top: 50px;
  font-family: 'Cormorant Garamond', serif;
}

.sello-superior {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  width: 110px;
  height: auto;
  z-index: 2;
}

.encabezado .titulo {
  font-size: 2.6rem;
  color: white;
  margin-bottom: 40px;
    font-family: 'subtitulos';

}

.encabezado .script {
  font-family: 'corinthia';
  font-size: 3rem;
  color: #e7d8cb;
  font-weight: normal;
  margin-left: 148px;
    margin-top: -3px;

}
.linea-eventos {
  display: flex;
  flex-direction: column;
  gap: 35px;
    padding-left: 50px;      /* ← Puedes ajustar el margen izquierdo si quieres más separación */

  align-items: center; /* centra cada bloque verticalmente */
}

.bloque-evento {
  display: flex;
  align-items: center;
  gap: 15px;
  opacity: 0;
  transform: translateY(50px);
  justify-content: flex-start;
  width: 100%;
  max-width: 300px; /* asegura que todos tengan la misma base visual */
}

.icono-evento {
  width: 32px;
  height: 32px;
  object-fit: contain;
  filter: brightness(0.95);
  flex-shrink: 0;
}

.detalle {
  text-align: left;
}

.detalle h3 {
  font-size: 18px;
  margin: 0;
  font-weight: 600;
  color: #fffaf3;
}

.detalle p {
  margin: 0;
  font-size: 15px;
  color: #ddd1c5;
}

</style>
